export const Policy = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="16"
            height="16"
            viewBox="0 0 219 230"
            enableBackground="new 0 0 219 230"
        >
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M115.000000,1.000002 
	C149.935287,1.000000 184.870560,1.000000 220.000000,1.000000 
	C220.000000,44.687370 220.000000,88.375023 219.603653,132.372177 
	C215.664337,132.289017 212.115479,131.942947 208.579437,131.495529 
	C194.310623,129.690170 181.572159,123.818031 169.459274,116.451538 
	C167.110947,115.023384 165.684616,114.951408 163.395874,116.660011 
	C154.645905,123.192078 144.792313,127.598351 134.072006,129.549072 
	C127.456360,130.752884 120.648003,130.897675 113.969872,131.513870 
	C113.969872,137.842163 113.620605,144.173477 114.040817,150.453308 
	C114.986687,164.588928 117.695358,178.361038 123.516586,191.414673 
	C132.090317,210.640594 146.785645,223.228409 166.000000,231.000000 
	C110.999985,231.000000 55.999962,231.000000 1.000000,231.000000 
	C1.000000,225.581650 1.000000,220.261276 1.337408,214.557831 
	C4.257603,220.625000 9.208585,222.801636 15.910370,222.779053 
	C50.908371,222.661148 85.906982,222.724106 120.905380,222.724167 
	C121.833267,222.724167 122.761154,222.724152 124.546478,222.724152 
	C122.112755,219.440277 119.825249,217.021439 118.340492,214.182739 
	C116.446915,210.562408 113.806305,209.816803 109.967239,209.836105 
	C79.969368,209.986969 49.970402,209.919571 19.971771,209.919586 
	C18.193983,209.919586 16.416195,209.919601 14.515702,209.919601 
	C14.515702,144.332809 14.515702,79.270943 14.515702,14.248515 
	C45.216164,14.248515 75.625259,14.248515 106.170120,14.248515 
	C106.170120,31.050877 106.137375,47.539268 106.185928,64.027428 
	C106.205887,70.802879 108.451569,72.995361 115.179962,73.011452 
	C126.179398,73.037750 137.178940,73.018867 148.178436,73.018990 
	C154.280670,73.019058 160.382919,73.019005 166.802170,73.019005 
	C166.802170,79.745468 166.695526,85.885681 166.881897,92.016983 
	C166.925064,93.437141 167.575134,95.380737 168.625488,96.127075 
	C171.810974,98.390533 175.329559,100.185181 179.458221,102.594139 
	C179.458221,92.995186 179.076736,84.206566 179.569031,75.467163 
	C180.031006,67.266403 178.204681,61.335564 171.471695,55.294128 
	C152.047562,37.865032 133.743774,19.187344 115.000000,1.000002 
M104.497818,105.917397 
	C84.029289,105.917427 63.560291,105.857765 43.093021,106.018074 
	C41.229225,106.032669 38.869053,107.017929 37.687943,108.376877 
	C36.827656,109.366684 36.824287,112.560020 37.684902,113.278542 
	C39.397488,114.708359 41.963306,115.811745 44.185707,115.828278 
	C67.648346,116.002792 91.112801,115.950523 114.576660,115.908363 
	C116.384117,115.905121 118.186470,115.452507 119.998909,115.300949 
	C123.182571,115.034721 124.810188,112.924156 123.854118,110.286972 
	C123.198730,108.479164 120.803391,106.371117 118.948708,106.115089 
	C114.539558,105.506401 109.989555,105.918030 104.497818,105.917397 
M78.499893,178.193741 
	C86.256416,178.193741 94.012939,178.193741 101.946297,178.193741 
	C101.092476,174.715973 100.354568,171.710312 99.558464,168.467636 
	C80.314438,168.467636 61.225922,168.446899 42.137539,168.487396 
	C38.827812,168.494415 36.737736,170.066162 36.903858,173.647141 
	C37.071560,177.262222 39.290970,178.258865 42.622009,178.231094 
	C54.247272,178.134140 65.873840,178.193680 78.499893,178.193741 
M54.508209,147.032196 
	C68.415871,147.032196 82.323532,147.032196 96.326233,147.032196 
	C96.139091,143.387512 95.980537,140.299347 95.811394,137.005096 
	C77.693024,137.005096 59.944527,136.986435 42.196140,137.021500 
	C38.817345,137.028183 36.889103,138.822083 36.940792,142.252594 
	C36.989403,145.478851 38.874187,147.021347 42.052044,147.028778 
	C45.872311,147.037704 49.692616,147.031723 54.508209,147.032196 
M66.499832,84.245674 
	C72.661888,84.245087 78.826149,84.145836 84.985138,84.282928 
	C88.385292,84.358604 90.631462,83.041702 90.741737,79.623611 
	C90.850548,76.251457 88.834473,74.587151 85.353775,74.597878 
	C71.031311,74.642006 56.708626,74.609726 42.386021,74.614563 
	C39.107876,74.615669 36.875751,75.859291 36.917404,79.527428 
	C36.959324,83.219414 39.227291,84.280853 42.517136,84.259712 
	C50.177757,84.210487 57.838921,84.245064 66.499832,84.245674 
M41.268940,45.347237 
	C37.887581,45.983765 36.411823,48.080925 36.987556,51.401516 
	C37.565590,54.735397 40.064564,55.213516 42.978844,55.177784 
	C50.110035,55.090363 57.244774,55.055424 64.374535,55.188858 
	C67.906471,55.254959 70.355888,54.156277 70.403557,50.339790 
	C70.450783,46.558105 68.091927,45.255901 64.532494,45.298340 
	C57.069553,45.387325 49.604828,45.326542 41.268940,45.347237 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M114.531342,1.000002 
	C133.743774,19.187344 152.047562,37.865032 171.471695,55.294128 
	C178.204681,61.335564 180.031006,67.266403 179.569031,75.467163 
	C179.076736,84.206566 179.458221,92.995186 179.458221,102.594139 
	C175.329559,100.185181 171.810974,98.390533 168.625488,96.127075 
	C167.575134,95.380737 166.925064,93.437141 166.881897,92.016983 
	C166.695526,85.885681 166.802170,79.745468 166.802170,73.019005 
	C160.382919,73.019005 154.280670,73.019058 148.178436,73.018990 
	C137.178940,73.018867 126.179398,73.037750 115.179962,73.011452 
	C108.451569,72.995361 106.205887,70.802879 106.185928,64.027428 
	C106.137375,47.539268 106.170120,31.050877 106.170120,14.248515 
	C75.625259,14.248515 45.216164,14.248515 14.515702,14.248515 
	C14.515702,79.270943 14.515702,144.332809 14.515702,209.919601 
	C16.416195,209.919601 18.193983,209.919586 19.971771,209.919586 
	C49.970402,209.919571 79.969368,209.986969 109.967239,209.836105 
	C113.806305,209.816803 116.446915,210.562408 118.340492,214.182739 
	C119.825249,217.021439 122.112755,219.440277 124.546478,222.724152 
	C122.761154,222.724152 121.833267,222.724167 120.905380,222.724167 
	C85.906982,222.724106 50.908371,222.661148 15.910370,222.779053 
	C9.208585,222.801636 4.257603,220.625000 1.337408,214.087372 
	C1.000000,214.000000 1.000000,213.500000 1.386485,213.049271 
	C1.845396,212.107559 1.981199,211.616608 1.981272,211.125610 
	C1.991011,145.590485 1.995982,80.055374 1.949837,14.520283 
	C1.949010,13.346633 1.330367,12.173418 1.000000,11.000000 
	C1.000000,11.000000 1.000000,10.500000 1.340381,10.163494 
	C3.193274,5.201872 6.498808,2.469768 11.000000,1.000000 
	C45.354229,1.000000 79.708458,1.000000 114.531342,1.000002 
M145.918930,48.579113 
	C137.223755,40.461140 128.528595,32.343166 119.312439,23.738800 
	C119.312439,36.260555 119.312439,47.943390 119.312439,59.708317 
	C132.052246,59.708317 144.554352,59.708317 157.702393,59.708317 
	C153.626221,55.849571 150.036377,52.451210 145.918930,48.579113 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M166.250000,231.000000 
	C146.785645,223.228409 132.090317,210.640594 123.516586,191.414673 
	C117.695358,178.361038 114.986687,164.588928 114.040817,150.453308 
	C113.620605,144.173477 113.969872,137.842163 113.969872,131.513870 
	C120.648003,130.897675 127.456360,130.752884 134.072006,129.549072 
	C144.792313,127.598351 154.645905,123.192078 163.395874,116.660011 
	C165.684616,114.951408 167.110947,115.023384 169.459274,116.451538 
	C181.572159,123.818031 194.310623,129.690170 208.579437,131.495529 
	C212.115479,131.942947 215.664337,132.289017 219.603653,132.840836 
	C220.000000,139.354401 220.000000,145.708786 219.618454,152.672791 
	C216.636490,164.689682 215.124939,176.487488 211.203918,187.421204 
	C203.564621,208.723175 187.685226,222.501709 167.000000,231.000000 
	C167.000000,231.000000 166.500000,231.000000 166.250000,231.000000 
M182.940247,144.850021 
	C174.370544,154.423355 165.800827,163.996689 157.019104,173.806885 
	C153.065659,168.641266 147.284073,166.001419 140.093094,167.269394 
	C138.872696,167.484589 137.193100,168.240311 136.819809,169.180634 
	C136.484467,170.025436 137.390610,171.704010 138.202698,172.606796 
	C142.729630,177.639328 147.693054,182.309418 151.904861,187.584396 
	C154.607574,190.969345 156.272446,195.182938 157.882385,198.086838 
	C170.434799,180.058121 183.106644,161.857895 195.747086,143.702744 
	C192.119019,143.890961 187.846695,144.112579 182.940247,144.850021 
z"
            />
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M167.468658,231.000000 
	C187.685226,222.501709 203.564621,208.723175 211.203918,187.421204 
	C215.124939,176.487488 216.636490,164.689682 219.618454,153.141190 
	C220.000000,178.912872 220.000000,204.825745 220.000000,231.000000 
	C202.646652,231.000000 185.291977,231.000000 167.468658,231.000000 
z"
            />
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M1.000000,11.468657 
	C1.330367,12.173418 1.949010,13.346633 1.949837,14.520283 
	C1.995982,80.055374 1.991011,145.590485 1.981272,211.125610 
	C1.981199,211.616608 1.845396,212.107559 1.386485,212.799271 
	C1.000000,145.979111 1.000000,78.958206 1.000000,11.468657 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M10.513435,1.000000 
	C6.498808,2.469768 3.193274,5.201872 1.340381,9.913494 
	C1.000000,7.076724 1.000000,4.153447 1.000000,1.000000 
	C4.006850,1.000000 7.016860,1.000000 10.513435,1.000000 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M104.997139,105.917397 
	C109.989555,105.918030 114.539558,105.506401 118.948708,106.115089 
	C120.803391,106.371117 123.198730,108.479164 123.854118,110.286972 
	C124.810188,112.924156 123.182571,115.034721 119.998909,115.300949 
	C118.186470,115.452507 116.384117,115.905121 114.576660,115.908363 
	C91.112801,115.950523 67.648346,116.002792 44.185707,115.828278 
	C41.963306,115.811745 39.397488,114.708359 37.684902,113.278542 
	C36.824287,112.560020 36.827656,109.366684 37.687943,108.376877 
	C38.869053,107.017929 41.229225,106.032669 43.093021,106.018074 
	C63.560291,105.857765 84.029289,105.917427 104.997139,105.917397 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M77.999901,178.193741 
	C65.873840,178.193680 54.247272,178.134140 42.622009,178.231094 
	C39.290970,178.258865 37.071560,177.262222 36.903858,173.647141 
	C36.737736,170.066162 38.827812,168.494415 42.137539,168.487396 
	C61.225922,168.446899 80.314438,168.467636 99.558464,168.467636 
	C100.354568,171.710312 101.092476,174.715973 101.946297,178.193741 
	C94.012939,178.193741 86.256416,178.193741 77.999901,178.193741 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M54.010555,147.032196 
	C49.692616,147.031723 45.872311,147.037704 42.052044,147.028778 
	C38.874187,147.021347 36.989403,145.478851 36.940792,142.252594 
	C36.889103,138.822083 38.817345,137.028183 42.196140,137.021500 
	C59.944527,136.986435 77.693024,137.005096 95.811394,137.005096 
	C95.980537,140.299347 96.139091,143.387512 96.326233,147.032196 
	C82.323532,147.032196 68.415871,147.032196 54.010555,147.032196 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M65.999847,84.245682 
	C57.838921,84.245064 50.177757,84.210487 42.517136,84.259712 
	C39.227291,84.280853 36.959324,83.219414 36.917404,79.527428 
	C36.875751,75.859291 39.107876,74.615669 42.386021,74.614563 
	C56.708626,74.609726 71.031311,74.642006 85.353775,74.597878 
	C88.834473,74.587151 90.850548,76.251457 90.741737,79.623611 
	C90.631462,83.041702 88.385292,84.358604 84.985138,84.282928 
	C78.826149,84.145836 72.661888,84.245087 65.999847,84.245682 
z"
            />
            <path
                fill="var(--fg-gray2-gray3)"
                opacity="1.000000"
                stroke="none"
                d="
M41.704887,45.337242 
	C49.604828,45.326542 57.069553,45.387325 64.532494,45.298340 
	C68.091927,45.255901 70.450783,46.558105 70.403557,50.339790 
	C70.355888,54.156277 67.906471,55.254959 64.374535,55.188858 
	C57.244774,55.055424 50.110035,55.090363 42.978844,55.177784 
	C40.064564,55.213516 37.565590,54.735397 36.987556,51.401516 
	C36.411823,48.080925 37.887581,45.983765 41.704887,45.337242 
z"
            />
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M146.182724,48.815979 
	C150.036377,52.451210 153.626221,55.849571 157.702393,59.708317 
	C144.554352,59.708317 132.052246,59.708317 119.312439,59.708317 
	C119.312439,47.943390 119.312439,36.260555 119.312439,23.738800 
	C128.528595,32.343166 137.223755,40.461140 146.182724,48.815979 
z"
            />
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M183.257309,144.592117 
	C187.846695,144.112579 192.119019,143.890961 195.747086,143.702744 
	C183.106644,161.857895 170.434799,180.058121 157.882385,198.086838 
	C156.272446,195.182938 154.607574,190.969345 151.904861,187.584396 
	C147.693054,182.309418 142.729630,177.639328 138.202698,172.606796 
	C137.390610,171.704010 136.484467,170.025436 136.819809,169.180634 
	C137.193100,168.240311 138.872696,167.484589 140.093094,167.269394 
	C147.284073,166.001419 153.065659,168.641266 157.019104,173.806885 
	C165.800827,163.996689 174.370544,154.423355 183.257309,144.592117 
z"
            />
        </svg>
    );
};
